/**
 * A reference to the party able to choose whether the gas is delivered for a particular period as found in a swing or interruptible contract.
 * tag: 41080
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryStreamElectingPartySide {
  /** Buyer */
  Buyer = 0,
  /** Seller */
  Seller = 1,
}
